import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-md-12" };
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_6 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_7 = ["placeholder", "disabled"];
const _hoisted_8 = { class: "col-md-12" };
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_10 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_11 = { class: "mb-0" };
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = { class: "col-md-12" };
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_15 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_16 = {
    key: 0,
    class: "col-md-12"
};
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_18 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_19 = {
    key: 1,
    class: "col-md-12"
};
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_21 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_22 = {
    key: 2,
    class: "col-md-12"
};
const _hoisted_23 = {
    key: 0,
    class: "form-group mb-15 mb-sm-20 mb-md-25"
};
const _hoisted_24 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_25 = {
    type: "button",
    class: "bg-transparent p-0 border-0 mt-2 text-warning lh-1 fw-medium"
};
const _hoisted_26 = { class: "position-relative" };
const _hoisted_27 = {
    key: 3,
    class: "mt-3"
};
const _hoisted_28 = { class: "d-block text-black fw-semibold mb-2" };
const _hoisted_29 = {
    class: "d-flex flex-wrap gap-2",
    style: { "max-height": "200px", "overflow-y": "auto" }
};
const _hoisted_30 = {
    key: 4,
    class: "col-md-12"
};
const _hoisted_31 = {
    key: 0,
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_32 = ["disabled"];
const _hoisted_33 = { class: "position-relative" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("form", {
                onSubmit: _cache[9] || (_cache[9] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.createNewCategorie && _ctx.createNewCategorie(...args)), ["prevent"]))
            }, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('common.title')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.categorieData.title) }]),
                                placeholder: _ctx.$t('forms.example') + ' Nouveauté',
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.categorieData.title) = $event)),
                                onChange: _cache[1] || (_cache[1] = (event) => _ctx.handleInput(event, 'title')),
                                required: "",
                                disabled: _ctx.actionDetected == _ctx.ActionCrud.EDIT
                            }, null, 42, _hoisted_7), [
                                [_vModelText, _ctx.categorieData.title]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.message')) + " * ", 1),
                            _createElementVNode("div", _hoisted_11, [
                                (_ctx.actionDetected == _ctx.ActionCrud.EDIT)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "border p-3 rounded bg-light",
                                        innerHTML: _ctx.categorieData.message
                                    }, null, 8, _hoisted_12))
                                    : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                        key: 1,
                                        class: "form-control shadow-none rounded-0 text-black",
                                        rows: "7",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.categorieData.message) = $event)),
                                        onInput: _cache[3] || (_cache[3] = (event) => _ctx.handleInput(event, 'message'))
                                    }, null, 544)), [
                                        [_vModelText, _ctx.categorieData.message]
                                    ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('forms.targetChoice')), 1),
                            _createVNode(_component_v_select, {
                                modelValue: _ctx.restaurantSelected,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.restaurantSelected) = $event)),
                                options: _ctx.originalRestaurant,
                                label: "name",
                                reduce: restaurant => restaurant.id,
                                placeholder: _ctx.$t('lists.restaurant'),
                                disabled: _ctx.actionDetected == _ctx.ActionCrud.EDIT
                            }, null, 8, ["modelValue", "options", "reduce", "placeholder", "disabled"])
                        ])
                    ]),
                    (_ctx.actionDetected == _ctx.ActionCrud.ADD)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('forms.sendingType')) + " * ", 1),
                                _createVNode(_component_v_select, {
                                    modelValue: _ctx.sendingType,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.sendingType) = $event)),
                                    options: _ctx.typeSending,
                                    label: "",
                                    reduce: type => type,
                                    placeholder: "Selectionner le type"
                                }, null, 8, ["modelValue", "options", "reduce"])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.actionDetected == _ctx.ActionCrud.ADD)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('forms.notificationType')) + " * ", 1),
                                _createVNode(_component_v_select, {
                                    modelValue: _ctx.notificationType,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.notificationType) = $event)),
                                    options: _ctx.notificationTypes,
                                    label: "label",
                                    reduce: type => type.value,
                                    placeholder: "Sélectionner le type de notification"
                                }, null, 8, ["modelValue", "options", "reduce"])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.sendingType == 'Individuel')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            (_ctx.actionDetected == _ctx.ActionCrud.ADD)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('forms.recipients')) + " * ", 1),
                                    _createVNode(_component_v_select, {
                                        modelValue: _ctx.userSelected,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.userSelected) = $event)),
                                        options: _ctx.originalUsers,
                                        label: "email",
                                        reduce: user => user.id,
                                        placeholder: "Selectionner un utilisateur",
                                        filterable: true,
                                        onSearch: _ctx.onSearchUsers,
                                        loading: _ctx.isLoadingUsers
                                    }, null, 8, ["modelValue", "options", "reduce", "onSearch", "loading"]),
                                    _createElementVNode("button", _hoisted_25, [
                                        _cache[10] || (_cache[10] = _createElementVNode("i", { class: "flaticon-users-group lh-1 me-1 position-relative top-2" }, null, -1)),
                                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.categorieData.destination.length) + " ajouté(s)", 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.categorieData.destination.length > 0 && _ctx.actionDetected == _ctx.ActionCrud.EDIT)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('forms.recipients')) + " * ", 1),
                            _createElementVNode("div", _hoisted_29, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categorieData.destination, (email, index) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                        class: "badge bg-success text-white p-2 rounded fs-13",
                                        key: index
                                    }, _toDisplayString(_ctx.getDisplayEmail(email)), 1));
                                }), 128))
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.actionDetected == _ctx.ActionCrud.ADD)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            (_ctx.actionDetected)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    (_ctx.isLoading)
                                        ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
                                        : (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: _normalizeClass(["default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success", { 'opacity-50 cursor-not-allowed': !_ctx.isFormValid }]),
                                            type: "submit",
                                            disabled: !_ctx.isFormValid
                                        }, _toDisplayString(_ctx.$t('common.create')), 11, _hoisted_32)),
                                    _createElementVNode("button", {
                                        type: "button",
                                        onClick: _cache[8] || (_cache[8] =
                                            //@ts-ignore
                                            (...args) => (_ctx.goBack && _ctx.goBack(...args))),
                                        class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                                    }, [
                                        _cache[11] || (_cache[11] = _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)),
                                        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('common.cancel')), 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ], 32)
        ])
    ]));
}
